//token字段
export const LOGIN_TOKEN_KEY = 'userToken'
export const WEB_SOCKET_TOKEN_KEY = 'WebSocketToken'
//uid
export const UID = 'UID'
//share_uid
export const SHARE_UID = 'SHARE_UID'
//购物车
export const MY_CART_KEY = 'MY_CART_KEY_V2'
export const MY_CART_LIST_KEY = 'MY_CART_LIST_KEY'
//支付订单检测KEY
export const PAY_ORDER_STATUS_CHECK_KEY = 'PAY_ORDER_STATUS_CHECK_KEY'
//输入记忆
export const INPUT_MEMORY_KEY = 'INPUT_MEMORY_KEY'
//用户信息
export const USER_INFO = 'USER_INFO'
//缓存到期KEY
export const CACHE_EXPIRE_KEY = 'UNI-APP-XIAOCHAO'
//地址刷新
export const ADDRESS_REFRESH = 'ADDRESS_REFRESH'
//编辑写信提示
export const EDIT_LETTER_TIP = 'EDIT_LETTER_TIP'
export const EDIT_LETTER_DATA = 'EDIT_LETTER_DATA'
//照片
export const EDIT_LETTER_PHOTO = 'EDIT_LETTER_PHOTO'
//代收服务
export const EDIT_COLLECT = 'EDIT_COLLECT'
//更改订单号
export const SET_TRADE_NO = 'SET_TRADE_NO'
//明信片
export const POSTCARD_FRONT = 'POSTCARD_FRONT'
export const POSTCARD_BACK = 'POSTCARD_BACK'
//寄件地址
export const SEND_ADDRESS = 'SEND_ADDRESS'
//收件地址
export const DELIVER_ADDRESS = 'DELIVER_ADDRESS'
//双地址
export const TWO_ADDRESS = "TWO_ADDRESS"
//WEB渲染html缓存
export const WEB_HTML = 'WEB_HTML'
//App推送跳转链接缓存
export const APP_PUSH_OPEN_PAGE = 'APP_PUSH_OPEN_PAGE'
//关注公众号推送提示
export const FOLLOW_QRCODE_PUSH_TIP = 'FOLLOW_QRCODE_PUSH_TIP'